import { inject } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, catchError, retry, throwError, timer } from 'rxjs';

const RETRY_COUNT = 2;
const RETRY_DELAY_MS = 2000;
const GRAPH_PHOTO_URL = 'https://graph.microsoft.com/v1.0/me/photo/$value';
export const SKIP_RETRY_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);
  const apiRef = `${req.method} ${req.urlWithParams || req.url}`;
  const isGraphPhotoApi = req.url.startsWith(GRAPH_PHOTO_URL);
  const skipRetryInterceptor = req.context.get(SKIP_RETRY_INTERCEPTOR);

  return next(req).pipe(
    retry({
      count: RETRY_COUNT,
      delay: (error: unknown) => {
        if (skipRetryInterceptor) {
          return throwError(() => error);
        }

        if (isGraphPhotoApi) {
          return throwError(() => error);
        }

        if (error instanceof HttpErrorResponse && (error.status === 408 || error.status === 504)) {
          return timer(RETRY_DELAY_MS);
        }

        return throwError(() => error);
      },
    }),
    catchError((error: unknown) => {
      if (skipRetryInterceptor) {
        return throwError(() => error);
      }

      if (isGraphPhotoApi) {
        return EMPTY;
      }

      if (error instanceof HttpErrorResponse) {
        if (error.status === 408) {
          return throwError(() => error);
        }

        const message =
          error.error?.message || error.message || 'Request failed after multiple retries.';
        toastr.error(`${message} | API: ${apiRef}`, 'Request Failed');
      } else {
        toastr.error(`Request failed after multiple retries. | API: ${apiRef}`, 'Request Failed');
      }

      return throwError(() => error);
    }),
  );
};
